module.exports = __webpack_public_path__ + "img/map-logo-sepia.3200132c.png";